<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <button @click="telecharger" v-if="valideEtape3" :disabled="isLoading"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          type="button">
          <i class="flaticon-download position-relative ms-5 fs-12"></i>
          <span v-if="!isLoading">Exporter</span>
          <span v-else>
            <span class="spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
            Export en cours...
          </span>
        </button>
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          type="button" v-if="!valideEtape3" disabled>
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          <span class="visually-hidden">Chargement...</span>
        </button>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-4 col-sm-12 col-lg-4 col-xl-4 col-xxl-4 col-xm-12">
        <div class="form-group mb-15 mb-sm-20 mb-md-25">
          <label class="d-block text-black fw-semibold mb-10"> Mot clé </label>
          <Field v-model="motCle" name="mot" type="text" aria-disabled="true"
            class="form-control shadow-none fs-md-15 text-black" placeholder="Recherche par mot clé" />
          <ErrorMessage name="mot" class="text-danger" />
        </div>
      </div>
      <div class="col-md-8 col-sm-12 col-lg-8 col-xl-8 col-xxl-8 col-xm-12">
        <div class="form-group mb-15 mb-sm-20 mb-md-25">
          <label class="d-block text-black fw-semibold mb-10">
            Etats
          </label>
          <Field name="etat" v-slot="{ field }" v-model="etat"
            class="form-control shadow-none fs-md-15 text-black">
            <Multiselect v-model="field.value" v-bind="field" mode="tags" :options="etatsOptions" :searchable="true"
              noResultText="Aucun enregistrement trouvé" placeholder="Rechercher par secteur" />
          </Field>
          <ErrorMessage name="secteur" class="text-danger" />
        </div>
      </div>
        </div>
      </div>
      
      <!-- Accordion pour les statistiques -->
      <div class="accordion mb-4" id="statisticsAccordion">
        <div class="accordion-item">
          <h2 class="accordion-header" id="statisticsHeader">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" 
                    data-bs-target="#statisticsCollapse" aria-expanded="false" aria-controls="statisticsCollapse">
              <i class="flaticon-chart me-2"></i>
              Statistiques des usagers
            </button>
            <button @click="exportStatisticsAsSVG" class="btn btn-sm btn-outline-primary ms-2" 
                    title="Exporter les statistiques en SVG">
              <i class="flaticon-download me-1"></i>
              Export SVG
            </button>
          </h2>
          <div id="statisticsCollapse" class="accordion-collapse collapse" aria-labelledby="statisticsHeader" 
               data-bs-parent="#statisticsAccordion">
            <div class="accordion-body" id="statisticsContent">
              <div class="row">
                <!-- Graphique 1: État général -->
                <div class="col-md-6 mb-4">
                  <div class="card">
                    <div class="card-header">
                      <h5 class="card-title mb-0">État général des usagers</h5>
                    </div>
                    <div class="card-body">
                      <canvas id="etatGeneralChart" width="400" height="200"></canvas>
                    </div>
                  </div>
                </div>
                
                <!-- Graphique 2: Places -->
                <div class="col-md-6 mb-4">
                  <div class="card">
                    <div class="card-header">
                      <h5 class="card-title mb-0">Répartition par places</h5>
                    </div>
                    <div class="card-body">
                      <canvas id="placesChart" width="400" height="200"></canvas>
                    </div>
                  </div>
                </div>
                
                <!-- Graphique 3: Documents -->
                <div class="col-md-6 mb-4">
                  <div class="card">
                    <div class="card-header">
                      <h5 class="card-title mb-0">Documents (NPI/IFU)</h5>
                    </div>
                    <div class="card-body">
                      <canvas id="documentsChart" width="400" height="200"></canvas>
                    </div>
                  </div>
                </div>
                
                <!-- Graphique 4: Informations personnelles -->
                <div class="col-md-6 mb-4">
                  <div class="card">
                    <div class="card-header">
                      <h5 class="card-title mb-0">Informations personnelles</h5>
                    </div>
                    <div class="card-body">
                      <canvas id="infosPersonnellesChart" width="400" height="200"></canvas>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Résumé statistique -->
              <div class="row mt-4">
                <div class="col-12">
                  <div class="card">
                    <div class="card-header">
                      <h5 class="card-title mb-0">Résumé statistique</h5>
                    </div>
                    <div class="card-body">
                      <div class="row text-center">
                        <div class="col-md-2 col-6 mb-3">
                          <div class="border-end">
                            <h4 class="text-success mb-1">{{ pointTotaux?.totalUsagersAJour || 0 }}</h4>
                            <p class="text-muted mb-0 small">À jour</p>
                          </div>
                        </div>
                        <div class="col-md-2 col-6 mb-3">
                          <h4 class="text-danger mb-1">{{ pointTotaux?.totalUsagersNonAJour || 0 }}</h4>
                          <p class="text-muted mb-0 small">Non à jour</p>
                        </div>
                        <div class="col-md-2 col-6 mb-3">
                          <h4 class="text-info mb-1">{{ pointTotaux?.totalUsagersAvecImage || 0 }}</h4>
                          <p class="text-muted mb-0 small">Avec image</p>
                        </div>
                        <div class="col-md-2 col-6 mb-3">
                          <h4 class="text-warning mb-1">{{ pointTotaux?.totalUsagersAvecNPI || 0 }}</h4>
                          <p class="text-muted mb-0 small">Avec NPI</p>
                        </div>
                        <div class="col-md-2 col-6 mb-3">
                          <h4 class="text-primary mb-1">{{ pointTotaux?.totalUsagersAvecIFU || 0 }}</h4>
                          <p class="text-muted mb-0 small">Avec IFU</p>
                        </div>
                        <div class="col-md-2 col-6 mb-3">
                          <h4 class="text-secondary mb-1">{{ totalElements || 0 }}</h4>
                          <p class="text-muted mb-0 small">Total</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <hr />
      
      <!-- Loader pour le tableau -->
      <div v-if="isLoadingTable" class="text-center py-5">
        <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
          <span class="visually-hidden">Chargement...</span>
        </div>
        <p class="mt-3 text-muted">Chargement des données...</p>
      </div>
      
      <div v-else class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                ###
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                #
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Nom complet
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                NPI
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                IFU
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Sexe
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Téléphone
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Catégorie
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Activité
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Détail
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(us, index) in usagers" :key="index">
              <td class="shadow-none lh-1 fw-medium text-primary">
                <div class="d-flex align-items-center justify-content-center">
                  <a v-if="(us.medias && us.medias.length > 0)" 
                     class="d-flex align-items-center" 
                     data-bs-toggle="modal"
                     @click="handleVoirImage(us.medias)" 
                     data-bs-target="#voirImageModal" 
                     style="cursor: pointer; text-decoration: none;">
                    <img :src="getUrlApiForFiles('Usagers', us.medias[(us.medias.length - 1)].nomMedia)" 
                         alt="PhotoUsager"
                         width="50" 
                         height="50" 
                         class="rounded-circle border border-2 border-light shadow-sm user-image"
                         style="object-fit: cover;"
                         @error="handleImageError" />
                  </a>
                  <div v-else class="d-flex align-items-center justify-content-center bg-light rounded-circle border border-2 border-light user-placeholder" 
                       style="width: 50px; height: 50px;">
                    <i class="fas fa-user text-muted" style="font-size: 20px;"></i>
                  </div>
                </div>
              </td>
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ us.matricule }}
              </td>

              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ us.full_name }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ us.npi }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ us.ifu }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ us.sexe }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ us.tel }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ afficher20Caracteres(us.activite) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ afficher20Caracteres(us.new_activite) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ afficher20Caracteres(us.nouveau_activite) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-end pe-0 sm">
                <div class="dropdown">
                  <span class="badge text-white bg-secondary fs-15 dropdown-toggle" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    Actions
                    <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li>
                      <router-link :to="`detail-usager/${us.matricule}`" type="button"
                        class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-view lh-1 me-8 position-relative top-1"></i>
                        Détails
                      </router-link>
                    </li>
                    <li>
                      <a @click="getApercu(us)" type="button" class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-send lh-1 me-8 position-relative top-1"></i>
                        Apercu du statut
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        
        <!-- Pagination -->
        <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
          <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
            @paginate="handlePaginate" />
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="imageModal" tabindex="-1" aria-labelledby="imageModalLabel" aria-hidden="true"
    ref="modalEl">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="imageModalLabel">Aperçu de l'image</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
        </div>
        <div class="modal-body d-flex justify-content-center align-items-center" style="min-height: 300px;">
          <img :src="currentImageUrl" alt="Image" class="img-fluid" />
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="voirImageModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-hidden="true" ref="voirImageModal">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white">
          <h1 class="modal-title fs-5">
            <i class="fas fa-image me-2"></i>
            Photo de l'usager
          </h1>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body d-flex justify-content-center align-items-center" style="min-height: 400px;">
          <div v-if="currentImageUrl" class="text-center">
            <img :src="currentImageUrl" 
                 alt="PhotoUsager" 
                 class="img-fluid rounded shadow-lg"
                 style="max-height: 500px; max-width: 100%; object-fit: contain;"
                 @error="handleModalImageError" />
            <div class="image-error text-center text-muted" style="display: none;">
              <i class="fas fa-exclamation-triangle" style="font-size: 4rem;"></i>
              <p class="mt-3">Erreur lors du chargement de l'image</p>
            </div>
          </div>
          <div v-else class="text-center text-muted">
            <i class="fas fa-image" style="font-size: 4rem;"></i>
            <p class="mt-3">Aucune image disponible</p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">
            <i class="fas fa-times me-2"></i>
            Fermer
          </button>
          <a v-if="currentImageUrl" 
             :href="currentImageUrl" 
             target="_blank" 
             class="btn btn-primary">
            <i class="fas fa-external-link-alt me-2"></i>
            Ouvrir dans un nouvel onglet
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Styles pour les images des usagers */
.user-image {
  transition: transform 0.2s ease-in-out;
}

.user-image:hover {
  transform: scale(1.05);
}

.user-placeholder {
  transition: all 0.2s ease-in-out;
}

.user-placeholder:hover {
  background-color: #e9ecef !important;
  transform: scale(1.05);
}

/* Styles pour le modal d'image */
.modal-body img {
  transition: all 0.3s ease-in-out;
}

.modal-body img:hover {
  transform: scale(1.02);
}

/* Animation pour les placeholders */
@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}

.user-placeholder {
  animation: pulse 2s infinite;
}
</style>
<script lang="ts">
import { ref, defineComponent, onMounted, watch } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import {
  showModal,
  suppression,
  separateur,
  format_Date,
  format_date,
  supprimerElement,
  error,
  checkPermission,
  dateActuelle,
  success,
  getUrlApiForFiles,
  afficher20Caracteres,
  downloadExcel,
} from "@/utils/utils";
import { Contrat } from "@/models/Contrat";
import ApiService from "@/services/ApiService";
import { Option } from "@/models/Option";
import PaginationComponent from "@/components/Utilities/Pagination.vue";
import JwtService from "@/services/JwtService";
import Multiselect from "@vueform/multiselect";
import axios from "axios";
import Swal from "sweetalert2";
import bootstrap from "bootstrap";
import Chart from 'chart.js/auto';
import html2canvas from 'html2canvas';

export default defineComponent({
  name: "EtatUsagers",
  components: {
    PaginationComponent,
    Field,
    ErrorMessage,
    Multiselect
  },
  setup: () => {
    // BEGIN PAGINATE
    const searchTerm = ref("");
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const secteursOptions = ref<Array<Option>>([]);
    const motCle = ref("");
    const dateFin = ref(dateActuelle());
    const dateDebut = ref(dateActuelle());
    const lemontant = ref("0");
    const donn = ref();
    const selectedItem = ref();
    const etat = ref([3]);
    const etatsOptions = ref<Array<any>>([
      { value: "1", label: "A jour" },
      { value: "2", label: "Non a jour" },
      { value: "3", label: "Tous" },
      { value: "4", label: "A au moins une place" },
      { value: "5", label: "A plus d'une place" },
      { value: "6", label: "Aucune place" },
      { value: "7", label: "A une image" },
      { value: "8", label: "A n'a aucune image" },
      { value: "9", label: "A un NPI" },
      { value: "10", label: "N'a pas de NPI" },
      { value: "11", label: "A un IFU" },
      { value: "12", label: "N'a pas d'IFU" },
      { value: "13", label: "A une date de naissance" },
      { value: "14", label: "N'a pas de date de naissance" },
      { value: "15", label: "A un sexe" },
      { value: "16", label: "N'a pas de sexe" },
      { value: "17", label: "A un telephone" },
      { value: "18", label: "N'a pas de telephone" },
      { value: "19", label: "A une adresse" },
      { value: "20", label: "N'a pas d'adresse" },
    ]);

    // END PAGINATE
    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        limit.value = limit_;
        actionRecherche(page_, limit_);
      } catch (error) {
        //
      }
    };

    const valideEtape3 = ref(true);
    const isLoading = ref(false);
    const recharger = () => {
      actionRecherche(page.value, limit.value);
    };
    const agent = ref();
    const agentOptions = ref();
    const usagers: any = ref<Array<any>>([]);
    
    // Variables pour les statistiques
    const pointTotaux = ref<any>(null);
    let etatGeneralChart: any = null;
    let placesChart: any = null;
    let documentsChart: any = null;
    let infosPersonnellesChart: any = null;
    
    // Variable pour le loader
    const isLoadingTable = ref(false);
    
    // Variables manquantes
    const currentImageUrl = ref('');
    const modalEl = ref(null);

    const openAndPrint = (url: string) => {
      const newWindow = window.open(url, "_blank");

      if (newWindow) {
        newWindow.onload = () => {
          newWindow.print();
        };
      } else {
        console.error("Impossible d'ouvrir la fenêtre");
      }
    };
    function openNewWindow(data: any, dossier = "Recu") {
      openAndPrint(getUrlApiForFiles(dossier, data.reference + ".pdf"));
    }
    const actionRecherche = async (pageParam = 1, limi = 10, searchTerm = "") => {
      const element = {
        motCle: motCle.value,
        page: page.value,
        totalPages: totalPages.value,
        limit: limit.value,
        totalElements: totalElements.value,
        mot: searchTerm,
        etat: etat.value,
      };
      donn.value = element;
      
      // Activer le loader
      isLoadingTable.value = true;
      
      try {
        const response = await axios.post("etats/usagers/liste", element);
        usagers.value = response.data.data.data.entities;
        totalPages.value = response.data.data.totalPages;
        limit.value = response.data.data.limit;
        totalElements.value = response.data.data.totalElements;
        
        // Récupérer les statistiques
        pointTotaux.value = response.data.data.pointTotaux;
        
        // Mettre à jour les graphiques
        updateCharts();
      } catch (err) {
        // error("Erreur");
      } finally {
        // Désactiver le loader
        isLoadingTable.value = false;
      }
    };

    const getPoint = async () => {
      try {
        valideEtape3.value = false;
        donn.value = {
          dateDebut:
            (dateDebut.value ? dateDebut.value : dateActuelle()) + " 00:00:00",
          dateFin:
            (dateFin.value ? dateFin.value : dateActuelle()) + " 23:59:59",
          motCle: motCle.value,
          acteur: agent.value,
        };
        const response = await axios.post("/getPoint", donn.value);
        openNewWindow({ reference: response.data.data });
        valideEtape3.value = true;
      } catch (error) {
        // error("Erreur");
      }
    };

    const getApercu = async (value: any) => {
      try {
        if (value) {
          const response = await axios.post("/getPointUsager", value);
          if ((response).status == 201) {
            openNewWindow({ reference: response.data.data }, "PointUsager");
          }
        }
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
      }

    }

    const telecharger = async () => {
      valideEtape3.value = false;
      isLoading.value = true;
      try {
        const element = {
          motCle: motCle.value,
          etat: etat.value,
        };
        // Utiliser ApiService au lieu d'axios directement pour avoir l'authentification
        ApiService.setHeader(); // S'assurer que les en-têtes d'authentification sont configurés
        const response = await ApiService.post("/etats/usagers/export", element);
        const downloadUrl = await getUrlApiForFiles("Excel", response.data.data + ".xlsx");

        await downloadExcel(downloadUrl);
        openAndPrint(getUrlApiForFiles("Excel", response.data.data + ".xlsx"));
        valideEtape3.value = true;
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
        valideEtape3.value = true;
      } finally {
        isLoading.value = false;
      }
    };
    watch(motCle, (newValue, oldValue) => {
      page.value = 1;
      limit.value = 10;
      totalPages.value = 0;
      totalElements.value = 0;
      motCle.value = newValue;
      actionRecherche(page.value, limit.value);
    });

     watch(etat, (newValue, oldValue) => {
      page.value = 1;
      limit.value = 10;
      totalPages.value = 0;
      totalElements.value = 0;
      etat.value = newValue;
      actionRecherche(page.value, limit.value);
    });

    // Cette fonction est appelée au clic
    function handleVoirImage(medias) {
      if (medias && medias.length > 0) {
        const lastMedia = medias[medias.length - 1]
        currentImageUrl.value = getUrlApiForFiles('Usagers', lastMedia.nomMedia)
      }
    }

    // Gestion des erreurs d'image
    function handleImageError(event) {
      event.target.style.display = 'none';
      const placeholder = event.target.nextElementSibling;
      if (placeholder) {
        placeholder.style.display = 'flex';
      }
    }

    // Gestion des erreurs d'image dans le modal
    function handleModalImageError(event) {
      event.target.style.display = 'none';
      const errorDiv = event.target.parentElement.querySelector('.image-error');
      if (errorDiv) {
        errorDiv.style.display = 'block';
      }
    }

    // Fonction pour créer et mettre à jour tous les graphiques
    const updateCharts = () => {
      if (!pointTotaux.value) return;
      
      createEtatGeneralChart();
      createPlacesChart();
      createDocumentsChart();
      createInfosPersonnellesChart();
    };

    // Graphique 1: État général
    const createEtatGeneralChart = () => {
      const ctx = document.getElementById('etatGeneralChart') as HTMLCanvasElement;
      if (!ctx) return;

      if (etatGeneralChart) {
        etatGeneralChart.destroy();
      }

      etatGeneralChart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: ['À jour', 'Non à jour'],
          datasets: [{
            data: [pointTotaux.value.totalUsagersAJour, pointTotaux.value.totalUsagersNonAJour],
            backgroundColor: ['#28a745', '#dc3545'],
            borderWidth: 2,
            borderColor: '#fff'
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { position: 'bottom' },
            tooltip: {
              callbacks: {
                label: function(context) {
                  const total = context.dataset.data.reduce((a, b) => a + b, 0);
                  const percentage = ((context.parsed / total) * 100).toFixed(1);
                  return `${context.label}: ${context.parsed} (${percentage}%)`;
                }
              }
            }
          }
        }
      });
    };

    // Graphique 2: Places
    const createPlacesChart = () => {
      const ctx = document.getElementById('placesChart') as HTMLCanvasElement;
      if (!ctx) return;

      if (placesChart) {
        placesChart.destroy();
      }

      placesChart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: ['Une place', 'Plusieurs places', 'Aucune place'],
          datasets: [{
            label: 'Nombre d\'usagers',
            data: [
              pointTotaux.value.totalElementsAvecUneSeulePlace,
              pointTotaux.value.totalElementsAvecPlusieursPlace,
              pointTotaux.value.totalUsagersAucunePlace
            ],
            backgroundColor: ['#007bff', '#ffc107', '#6c757d'],
            borderWidth: 1
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false }
          },
          scales: {
            y: { beginAtZero: true }
          }
        }
      });
    };

    // Graphique 3: Documents
    const createDocumentsChart = () => {
      const ctx = document.getElementById('documentsChart') as HTMLCanvasElement;
      if (!ctx) return;

      if (documentsChart) {
        documentsChart.destroy();
      }

      documentsChart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: ['Avec NPI', 'Sans NPI', 'Avec IFU', 'Sans IFU'],
          datasets: [{
            data: [
              pointTotaux.value.totalUsagersAvecNPI,
              pointTotaux.value.totalUsagersSansNPI,
              pointTotaux.value.totalUsagersAvecIFU,
              pointTotaux.value.totalUsagersSansIFU
            ],
            backgroundColor: ['#17a2b8', '#fd7e14', '#6f42c1', '#e83e8c'],
            borderWidth: 2,
            borderColor: '#fff'
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { position: 'bottom' },
            tooltip: {
              callbacks: {
                label: function(context) {
                  const total = context.dataset.data.reduce((a, b) => a + b, 0);
                  const percentage = ((context.parsed / total) * 100).toFixed(1);
                  return `${context.label}: ${context.parsed} (${percentage}%)`;
                }
              }
            }
          }
        }
      });
    };

    // Graphique 4: Informations personnelles
    const createInfosPersonnellesChart = () => {
      const ctx = document.getElementById('infosPersonnellesChart') as HTMLCanvasElement;
      if (!ctx) return;

      if (infosPersonnellesChart) {
        infosPersonnellesChart.destroy();
      }

      infosPersonnellesChart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: ['Avec image', 'Sans image', 'Avec téléphone', 'Sans téléphone', 'Avec adresse', 'Sans adresse'],
          datasets: [{
            label: 'Nombre d\'usagers',
            data: [
              pointTotaux.value.totalUsagersAvecImage,
              pointTotaux.value.totalUsagersSansImage,
              pointTotaux.value.totalUsagersAvecTelephone,
              pointTotaux.value.totalUsagersSansTelephone,
              pointTotaux.value.totalUsagersAvecAdresse,
              pointTotaux.value.totalUsagersSansAdresse
            ],
            backgroundColor: ['#20c997', '#dc3545', '#0dcaf0', '#fd7e14', '#198754', '#6c757d'],
            borderWidth: 1
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false }
          },
          scales: {
            y: { beginAtZero: true }
          }
        }
      });
    };


    // Fonction pour exporter les statistiques en SVG
    const exportStatisticsAsSVG = async () => {
      try {
        // Ouvrir l'accordion si il est fermé
        const collapseElement = document.getElementById('statisticsCollapse');
        if (collapseElement && !collapseElement.classList.contains('show')) {
          const bsCollapse = new (window as any).bootstrap.Collapse(collapseElement, { show: true });
          await new Promise(resolve => setTimeout(resolve, 500));
        }

        // Attendre que les graphiques soient rendus
        await new Promise(resolve => setTimeout(resolve, 1000));

        const element = document.getElementById('statisticsContent');
        if (!element) {
          error('Élément des statistiques non trouvé');
          return;
        }

        // Utiliser html2canvas pour capturer l'élément
        const canvas = await html2canvas(element, {
          backgroundColor: '#ffffff',
          scale: 2,
          useCORS: true,
          allowTaint: true
        });

        // Convertir en image
        const imageData = canvas.toDataURL('image/png');
        
        // Créer un lien de téléchargement
        const link = document.createElement('a');
        link.download = `statistiques_usagers_${new Date().toISOString().split('T')[0]}.png`;
        link.href = imageData;
        link.click();

        success('Statistiques exportées avec succès !');
      } catch (err) {
        console.error('Erreur lors de l\'export:', err);
        error('Erreur lors de l\'export des statistiques');
      }
    };

    onMounted(async () => {
      await actionRecherche(1, 10);
    });
    return {
      handleVoirImage,
      handleImageError,
      handleModalImageError,
      currentImageUrl,
      dateDebut,
      dateFin,
      suppression,
      recharger,
      page,
      agentOptions,
      agent,
      openNewWindow,
      usagers,
      secteursOptions,
      totalPages,
      limit,
      format_date,
      format_Date,
      separateur,
      totalElements,
      handlePaginate,
      searchTerm,
      motCle,
      error,
      lemontant,
      getPoint,
      valideEtape3,
      isLoading,
      selectedItem,
      afficher20Caracteres,
      dateActuelle,
      getUrlApiForFiles,
      getApercu,
      telecharger,
      etat,
      etatsOptions,
      checkPermission,
      pointTotaux,
      exportStatisticsAsSVG,
      updateCharts,
      isLoadingTable,
      modalEl
    };
  },
});
</script>
